/* eslint-disable import/prefer-default-export */
export enum PagingOptions {
  Default,
  All,
}
